module.exports = __webpack_public_path__ + "media/images/sign_in_with_google-3902b8136696fe762e67626880074cae.png";